import * as React from 'react';

import BaseSalesListLayout from './BaseSalesListLayout';
import SaleDeletePopup from "~/apps/pos/admin/containers/sales/SaleDeletePopup";

export default function ({saleId}) {
  return BaseSalesListLayout(
    <SaleDeletePopup saleId={saleId}/>
  );
};
